import { STATUS } from "@/utils/constants";

import {
  getMyobAccounts,
  getMyobItems,
  getMyobJobs,
  getMyobLocations,
  getMyobTaxCodes,
  getQboAccounts,
  getQboItems,
  getQboTaxCodes,
  getUpdateAllData,
  getXeroAccounts,
  getXeroConnectionStatus,
  getXeroItems,
  getXeroTrackingCategories,
  postMyobJobs,
} from "../../apiv2/accounting";
import { handleError } from "../utils/error";

import {
  SET_ACCOUNTING_UPDATE_ALL_STATUS,
  SET_ACCOUNTS,
  SET_CREATE_MYOB_JOBS_STATUS,
  SET_CREATED_MYOB_JOB,
  SET_IS_ACCOUNTS_TAX_CODES_MODAL_OPEN,
  SET_IS_CONNECTED_ACCOUNTING_MODAL_OPEN,
  SET_IS_CONNECTING,
  SET_IS_DISCONNECT_ACCOUNTING_MODAL_OPEN,
  SET_IS_FETCHING,
  SET_IS_IMPORT_CUSTOMERS_MODAL_OPEN,
  SET_IS_IMPORT_SUPPLIERS_MODAL_OPEN,
  SET_IS_MYOB_COMPANY_FILE_MODAL_OPEN,
  SET_IS_XERO_CONNECTED,
  SET_ITEMS,
  SET_MYOB_JOBS,
  SET_MYOB_LOCATIONS,
  SET_SELECTED_MYOB_COMPANY_FILE,
  SET_TAX_CODES,
  SET_XERO_TRACKING_CATEGORIES,
} from "./accounting.actionTypes";

export const setIsFetching = (status) => (dispatch) => {
  dispatch({
    type: SET_IS_FETCHING,
    payload: status,
  });
};

export const setIsConnecting =
  ({ status, accountingName }) =>
  (dispatch) => {
    dispatch({
      type: SET_IS_CONNECTING,
      payload: { status, accountingName },
    });
  };

export const setAccounts = (data) => (dispatch) => {
  dispatch({
    type: SET_ACCOUNTS,
    payload: {
      data,
    },
  });
};

export const setTaxCodes = (data) => (dispatch) => {
  dispatch({
    type: SET_TAX_CODES,
    payload: {
      data,
    },
  });
};

export const setItems = (data) => (dispatch) => {
  dispatch({
    type: SET_ITEMS,
    payload: {
      data,
    },
  });
};

export const setMyobJobs = (data) => (dispatch) => {
  dispatch({
    type: SET_MYOB_JOBS,
    payload: {
      data,
    },
  });
};

export const setMyobLocations = (data) => (dispatch) => {
  dispatch({
    type: SET_MYOB_LOCATIONS,
    payload: {
      data,
    },
  });
};

export const setCreateMyobJobsStatus = (payload) => (dispatch) => {
  dispatch({
    type: SET_CREATE_MYOB_JOBS_STATUS,
    payload,
  });
};

export const setCreatedMyobJob = (payload) => (dispatch) => {
  dispatch({
    type: SET_CREATED_MYOB_JOB,
    payload,
  });
};

export const setXeroTrackingCategories = (data) => (dispatch) => {
  dispatch({
    type: SET_XERO_TRACKING_CATEGORIES,
    payload: {
      data,
    },
  });
};

export const setAccountingUpdateAllStatus = (payload) => (dispatch) => {
  dispatch({
    type: SET_ACCOUNTING_UPDATE_ALL_STATUS,
    payload,
  });
};

export const setIsXeroConnected = (status) => (dispatch) => {
  dispatch({
    type: SET_IS_XERO_CONNECTED,
    payload: status,
  });
};

export const setIsUpdatingAllData =
  (params = {}) =>
  async (dispatch) => {
    try {
      dispatch(setAccountingUpdateAllStatus(STATUS.PENDING));
      await getUpdateAllData(params)();
      dispatch(setAccountingUpdateAllStatus(STATUS.FULFILLED));
    } catch (error) {
      dispatch(setAccountingUpdateAllStatus(STATUS.REJECTED));
      handleError(error, dispatch);
    }
  };

export const fetchMyobAccounts = () => async (dispatch) => {
  try {
    dispatch(setIsFetching(true));
    const response = await getMyobAccounts()();
    dispatch(setAccounts(response.data));
  } catch (error) {
    handleError(error, dispatch);
  } finally {
    dispatch(setIsFetching(false));
  }
};

export const fetchMyobAccountsTaxCodes = () => async (dispatch) => {
  try {
    dispatch(setIsFetching(true));
    const response = await getMyobAccounts()();
    dispatch(setAccounts(response.data));
    const taxCodesResponse = await getMyobTaxCodes()();
    dispatch(setTaxCodes(taxCodesResponse.data));
    const locationsResponse = await getMyobLocations()();
    dispatch(setMyobLocations(locationsResponse.data));
  } catch (error) {
    handleError(error, dispatch);
  } finally {
    dispatch(setIsFetching(false));
  }
};

export const fetchQboAccountsTaxCodes = () => async (dispatch) => {
  try {
    dispatch(setIsFetching(true));
    const accountsResponse = await getQboAccounts()();
    dispatch(setAccounts(accountsResponse.data));
    const taxCodesResponse = await getQboTaxCodes()();
    dispatch(setTaxCodes(taxCodesResponse.data));
  } catch (error) {
    handleError(error, dispatch);
  } finally {
    dispatch(setIsFetching(false));
  }
};

export const fetchXeroAccounts = () => async (dispatch) => {
  try {
    dispatch(setIsFetching(true));
    const accountsResponse = await getXeroAccounts()();
    dispatch(setAccounts(accountsResponse.data));
  } catch (error) {
    handleError(error, dispatch);
  } finally {
    dispatch(setIsFetching(false));
  }
};

export const fetchMyobJobs =
  (params = {}) =>
  async (dispatch) => {
    try {
      dispatch(setIsFetching(true));
      const response = await getMyobJobs(params)();
      dispatch(setMyobJobs(response.data));
    } catch (error) {
      handleError(error, dispatch);
    } finally {
      dispatch(setIsFetching(false));
    }
  };

export const fetchMyobLocations = () => async (dispatch) => {
  try {
    dispatch(setIsFetching(true));
    const response = await getMyobLocations()();
    dispatch(setMyobLocations(response.data));
  } catch (error) {
    handleError(error, dispatch);
  } finally {
    dispatch(setIsFetching(false));
  }
};

export const fetchMyobItems = () => async (dispatch) => {
  try {
    dispatch(setIsFetching(true));
    const response = await getMyobItems()();
    dispatch(setItems(response.data));
  } catch (error) {
    handleError(error, dispatch);
  } finally {
    dispatch(setIsFetching(false));
  }
};

export const fetchQboItems = () => async (dispatch) => {
  try {
    dispatch(setIsFetching(true));
    const response = await getQboItems()();
    dispatch(setItems(response.data));
  } catch (error) {
    handleError(error, dispatch);
  } finally {
    dispatch(setIsFetching(false));
  }
};

export const fetchXeroItems = () => async (dispatch) => {
  try {
    dispatch(setIsFetching(true));
    const response = await getXeroItems()();
    dispatch(setItems(response.data));
  } catch (error) {
    handleError(error, dispatch);
  } finally {
    dispatch(setIsFetching(false));
  }
};

export const fetchXeroTrackingCategories =
  (params = {}) =>
  async (dispatch) => {
    try {
      dispatch(setIsFetching(true));
      const response = await getXeroTrackingCategories(params)();
      dispatch(setXeroTrackingCategories(response.data));
    } catch (error) {
      handleError(error, dispatch);
    } finally {
      dispatch(setIsFetching(false));
    }
  };

export const setSelectedMyobCompanyFile = (data) => (dispatch) => {
  dispatch({
    type: SET_SELECTED_MYOB_COMPANY_FILE,
    payload: {
      data,
    },
  });
};

export const setIsMyobCompanyFileModalOpen =
  ({ status, myobCompanyFiles }) =>
  (dispatch) => {
    dispatch({
      type: SET_IS_MYOB_COMPANY_FILE_MODAL_OPEN,
      payload: {
        status,
        myobCompanyFiles,
      },
    });
  };

export const setIsConnectedAccountingModalOpen =
  ({ status, newAccountingDefault }) =>
  (dispatch) => {
    dispatch({
      type: SET_IS_CONNECTED_ACCOUNTING_MODAL_OPEN,
      payload: {
        status,
        newAccountingDefault,
      },
    });
  };

export const setIsDisconnectAccountingModalOpen =
  ({ status }) =>
  (dispatch) => {
    dispatch({
      type: SET_IS_DISCONNECT_ACCOUNTING_MODAL_OPEN,
      payload: {
        status,
      },
    });
  };

export const setIsAccountsTaxCodesModalOpen =
  ({ status }) =>
  (dispatch) => {
    dispatch({
      type: SET_IS_ACCOUNTS_TAX_CODES_MODAL_OPEN,
      payload: {
        status,
      },
    });
  };

export const setIsImportSuppliersModalOpen =
  ({ status }) =>
  (dispatch) => {
    dispatch({
      type: SET_IS_IMPORT_SUPPLIERS_MODAL_OPEN,
      payload: {
        status,
      },
    });
  };

export const setIsImportCustomersModalOpen =
  ({ status }) =>
  (dispatch) => {
    dispatch({
      type: SET_IS_IMPORT_CUSTOMERS_MODAL_OPEN,
      payload: {
        status,
      },
    });
  };

export const fetchXeroConnectionStatus = () => async (dispatch) => {
  try {
    const { data } = await getXeroConnectionStatus()();

    dispatch(setIsXeroConnected(data.isConnected));

    return data;
  } catch (error) {
    handleError(error, dispatch);
    return null;
  }
};

export const createMyobJob = (data) => async (dispatch) => {
  try {
    dispatch(setCreateMyobJobsStatus(STATUS.PENDING));
    const response = await postMyobJobs(data)();
    dispatch(setCreateMyobJobsStatus(STATUS.FULFILLED));
    dispatch(setCreatedMyobJob(response.data));
    return response;
  } catch (error) {
    dispatch(setCreateMyobJobsStatus(STATUS.REJECTED));
    dispatch(setCreatedMyobJob(null));
    handleError(error, dispatch);
    return null;
  }
};
